import React from "react";
import PropTypes from "prop-types";
import { activityTypes } from "../../constants";
import {
  DesktopMacOutlined as CourseIcon,
  Backup as UploadIcon,
  Description as PageIcon,
  FormatListBulleted as ListIcon,
  Link as LinkIcon,
  Forum as DiscussionIcon,
  Help as CourseQuizIcon,
  Videocam as VideoIcon,
  Language as ScormIcon,
  Description as FileIcon,
  Image as ImageIcon,
  CheckCircle as AcknowledgementIcon
} from "@mui/icons-material";
import HomeworkIcon from "./HomeworkIcon";
import RepositoryItemIcon from "./RepositoryItemIcon";
import CourseSurveyIcon from "./CourseSurveyIcon";
import PolicyIcon from "./PolicyPartnerIcon";
import PolicyDocumentIcon from "./PolicyDocumentIcon";

function CourseActivityIcon({ type, ...iconProps }) {
  switch (type && type.toLowerCase()) {
    case activityTypes.link.toLowerCase():
      return <LinkIcon {...iconProps} />;
    case activityTypes.scorm.toLowerCase():
      return <ScormIcon {...iconProps} />;
    case activityTypes.video.toLowerCase():
      return <VideoIcon {...iconProps} />;
    case activityTypes.file.toLowerCase():
      return <FileIcon {...iconProps} />;
    case activityTypes.quiz.toLowerCase():
      return <CourseQuizIcon {...iconProps} />;
    case activityTypes.survey.toLowerCase():
      return <CourseSurveyIcon {...iconProps} />;
    case activityTypes.upload.toLowerCase():
      return <UploadIcon {...iconProps} />;
    case activityTypes.page.toLowerCase():
    case activityTypes.document.toLowerCase():
      return <PageIcon {...iconProps} />;
    case activityTypes.checklist.toLowerCase():
      return <ListIcon {...iconProps} />;
    case activityTypes.discussion.toLowerCase():
      return <DiscussionIcon {...iconProps} />;
    case activityTypes.homework.toLowerCase():
      return <HomeworkIcon {...iconProps} />;
    case activityTypes.repositoryItem.toLowerCase():
      return <RepositoryItemIcon {...iconProps} />;
    case activityTypes.policy.toLowerCase():
      return <PolicyIcon {...iconProps} />;
    case activityTypes.course.toLowerCase():
      return <CourseIcon {...iconProps} />;
    case activityTypes.image.toLowerCase():
      return <ImageIcon {...iconProps} />;
    case activityTypes.policyDocument.toLowerCase():
      return <PolicyDocumentIcon {...iconProps} />;
    case activityTypes.acknowledgement.toLowerCase():
      return <AcknowledgementIcon {...iconProps} />;
    default:
      return null;
  }
}

export default CourseActivityIcon;

CourseActivityIcon.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string
};

CourseActivityIcon.defaultProps = {
  type: "",
  color: "inherit"
};
